import React, { FC, useEffect } from 'react'
import { IFormItem } from '../Types'
import { Form, Input, Tooltip } from 'antd'
import { CopyOutlined, ExclamationCircleFilled, ExclamationCircleOutlined, EyeOutlined } from '@ant-design/icons'

export const __FormInput: FC<IFormItem> = ({ placeholder, fieldLabel, fieldName, addonAfter, ...props }) => {
    return (
        <Form.Item
            // label={fieldLabel}
            label={props.detialVal ?
                <Tooltip title={props.detialVal}>{fieldLabel}
                    <CopyOutlined
                        style={{ fontSize: '13px', color: '#4062d8', marginLeft: '5px' }}
                        onClick={(e) => {
                            e.stopPropagation()
                            props?.copyText?.(fieldName as string)
                        }}
                    />
                    <EyeOutlined style={{ fontSize: '15px', color: '#4062d8', marginLeft: '5px' }} />
                </Tooltip> :
                props.waring ?
                    <span>
                        {fieldLabel}{' '}
                        <CopyOutlined
                            style={{ fontSize: '13px', color: '#4062d8' }}
                            onClick={(e) => {
                                e.stopPropagation()
                                props?.copyText?.(fieldName as string)
                            }}
                        />
                        <Tooltip title={props.waring}>
                            <ExclamationCircleOutlined style={{ fontSize: '17px', color: '#fe6b00', marginLeft: '5px', cursor: 'pointer' }} />
                        </Tooltip>
                    </span>
                    :
                    <span>
                        {fieldLabel}{' '}
                        <CopyOutlined
                            style={{ fontSize: '13px', color: '#4062d8' }}
                            onClick={(e) => {
                                e.stopPropagation()
                                props?.copyText?.(fieldName as string)
                            }}
                        />
                    </span>
            }
            // label={
            //     <span>
            //         {fieldLabel}{' '}
            //         <CopyOutlined
            //             style={{ fontSize: '13px', color: '#4062d8' }}
            //             onClick={(e) => {
            //                 e.stopPropagation()
            //                 props?.copyText?.(fieldName as string)
            //             }}
            //         />
            //     </span>
            // }
            name={fieldName}
            rules={props.rules}
            hidden={props.hidden}
            labelCol={props.labelCol ?? { span: 24 }}
        >
            <Input
                disabled={props.disable}
                allowClear={props.allowClear}
                placeholder={placeholder ? placeholder : typeof fieldLabel === 'string' ? fieldLabel : ''}
                prefix={props.prefix}
                onBlur={(e) => props.onInputBlur?.(e)}
                onFocus={() => props.onInputFocus?.()}
                suffix={props.suffix}
                addonAfter={addonAfter}
            />
        </Form.Item>
    )
}
